import styled from 'styled-components';

export const PageContainer = styled.div`
  margin: 0 1em;
  position: relative;
`;

export const Header = styled.h1`
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;

  /* Outrank the global h1:first-child/:last-child margin resets. */
  && {
    margin-top: 32px;
    margin-bottom: 8px;
  }
`;

export const ProductWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 640px) {
    flex-direction: row;
  }
`;

export const ProductLabel = styled.div`
  font-size: 14px;
  margin-bottom: 8px;

  @media screen and (min-width: 640px) {
    margin-bottom: 0;
  }
`;

export const PasswordHeader = styled.h2`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;

  /* Outrank the global h2 and h2:first-child margins. */
  && {
    margin-top: 32px;
    margin-bottom: 0;
  }
`;

export const PasswordBody = styled.div`
  font-size: 16px;
  line-height: 24px;
`;
